module.exports = __webpack_public_path__ + "img/gyoza_raw.85927f36.jpg";